import * as React from 'react'

import { getActiveTargetCount, getDisplayableTargetType } from './service-utils'
import CharacteristicsTags from './CharacteristicsTags'

import Divider from 'components/common/Divider'
import Text from 'components/common/Text'
import theme from 'theme'
import { sortBy } from 'utils/list'
import { Service } from 'api'

const ServiceCharacteristics: React.FC<{
  service: Service
  truncateList?: boolean
}> = ({ service, truncateList = false }) => {
  const tags = React.useMemo(() => {
    return [
      [undefined, getDisplayableTargetType(service).toLowerCase()],
      ['active targets', getActiveTargetCount(service)]
    ].concat(
      sortBy(
        Object.entries(service.characteristics),
        // Sort by key, then length of key + value
        [([k]) => k, ([k, v]) => `${k}${v}`.length]
      )
    )
  }, [service])

  return (
    <CharacteristicsTags
      tags={tags}
      tooltipContent={
        <>
          {service.description && (
            <>
              <div
                css={{
                  display: 'grid',
                  gap: theme.space[2]
                }}
              >
                <Text as="h4">Description</Text>
                <Text as="small" color="medium">
                  {service.description}
                </Text>
              </div>
              <Divider />
            </>
          )}
          <ServiceCharacteristics service={service} />
        </>
      }
      truncateList={truncateList}
    />
  )
}

export default React.memo(ServiceCharacteristics)
